/* Fancybox to zoom and gallery article images */
/* Works with useEffect inside Article component */

import React, { useEffect } from 'react'
import { Fancybox as NativeFancybox } from '@fancyapps/ui/dist/fancybox.esm'
import '@fancyapps/ui/dist/fancybox.css'

function Fancybox(props) {
    const delegate = props.delegate || "[data-fancybox]"

    useEffect(() => {
        const opts = props.options || {}

        NativeFancybox.bind(delegate, opts)

        return () => {
            NativeFancybox.destroy()
        };
    }, []);

    return <div style={{ zIndex: 2002 }}>{props.children}</div>
}

export default Fancybox